<script setup>
import { ref, reactive, computed, watch, onMounted } from "vue";
import ShipmentTypeToggle from "./purchase-rent-plan/Shipment/ShipmentTypeToggle.vue";
import { useShipmentStore } from "../../../store/shipmentStore";
import _ from "lodash";
import ShipmentPickupForm from "./purchase-rent-plan/Shipment/ShipmentPickupForm.vue";
import ShipmentDeliveryForm from "./purchase-rent-plan/Shipment/ShipmentDeliveryForm.vue";

const shipmentStore = useShipmentStore();
</script>

<template>
    <div class="purchase-rent-shipment">
        <div class="mb-2">
            <h1>{{ $t("purchase-rent-page.shipment.title") }}</h1>
        </div>

        <div class="mb-4">
            <!-- Shipment Type Toggle -->
            <ShipmentTypeToggle />
        </div>

        <div
            v-if="shipmentStore.shipment_type === 'pickup'"
        >
            <ShipmentPickupForm />
        </div>

        <div
            v-if="shipmentStore.shipment_type === 'delivery'"
        >
            <ShipmentDeliveryForm />
        </div>
    </div>
</template>
